import { Icon, IconProps } from "@chakra-ui/react";
import React from "react";
import { HiOutlineExclamationCircle } from "react-icons/hi";

export const CheckMarkCircle = (props: IconProps): JSX.Element => (
  <Icon color="green.400" {...props}>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m9 12l2 2l4-4m6 2a9 9 0 1 1-18 0a9 9 0 0 1 18 0Z"
    />
  </Icon>
);

export const ExclamationCircle = (): JSX.Element => (
  <Icon
    as={HiOutlineExclamationCircle}
    mr="1"
    color="red.400"
    mt="1"
    fontSize="2xl"
  />
);
